export const FETCH_DRAWER_TYPE = 'FETCH_DRAWER_TYPE';

export const fetchDrawerType = ({ display, view }) => ({
  type: FETCH_DRAWER_TYPE,
  payload: { display, view },
});
